import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert, Button } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { API_BASE_URL } from "../../config/api";

export default function AuthCallbackPage() {
  const [searchParams]         = useSearchParams();
  const navigate                = useNavigate();
  const { loginWithTokenData }  = useAuth();
  const [error, setError]       = useState("");
  const didRun                  = useRef(false);

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;

    const code       = searchParams.get("code");
    const errorParam = searchParams.get("error");
    const stateRaw    = searchParams.get("state");

    if (!code && !errorParam && !stateRaw) {
      navigate("/login", { replace: true });
      return;
    }

    if (errorParam) {
      setError(`Erro SSO: ${searchParams.get("error_description") || errorParam}`);
      return;
    }
    if (!code) {
      setError("Código de autorização não recebido.");
      return;
    }

    let provider = "sap";
    let configId = null;
    try {
      const state = JSON.parse(atob(stateRaw || ""));
      provider = state.provider ?? "sap";
      configId = state.configId ?? null;
    } catch {
      setError("Parâmetro state inválido.");
      return;
    }

    if (!configId) {
      setError("Configuração SSO não identificada no retorno.");
      return;
    }

    const endpoint = provider === "microsoft"
      ? `${API_BASE_URL}/auth/microsoft/callback`
      : `${API_BASE_URL}/auth/sap/callback`;

    const providerLabel = provider === "microsoft" ? "Microsoft" : "SAP";

    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, configId, redirectUri: window.location.origin + "/auth/callback" }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.accessToken) {
          loginWithTokenData(data);
          navigate("/inbound", { replace: true });
        } else {
          setError(data.error || `Falha na autenticação com ${providerLabel}.`);
        }
      })
      .catch(() => setError(`Erro de conexão ao processar autenticação ${providerLabel}.`));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", gap: 2 }}>
        <Alert severity="error" sx={{ maxWidth: 400 }}>{error}</Alert>
        <Button variant="outlined" onClick={() => navigate("/login", { replace: true })}>
          Voltar ao login
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">Autenticando...</Typography>
    </Box>
  );
}
